<jhi-custom-box [title]="'spans.notallowedorganization.boxtitle'"
                [subTitle]="'spans.notallowedorganization.maintext'"
                [boxSize]="'box-620'"
                [contentLoading]="loading">

    <div class="d-flex" *ngIf="goToUrl">
        <button type="button" class="btn btn-primary ml-auto mr-auto"
                (click)="goToOtherSelfService()" jhiTranslate="buttons.continue">Go to</button>
    </div>
</jhi-custom-box>
